export const TRUSTPILOT_REVIEWS_KEY = "$trustpilotReviews";
export const TRUSTPILOT_SCORE_KEY = "$trustpilotScore";
export const TRUSTPILOT_SCORE_STRING_KEY = "$trustpilotScoreString";
export const GOOGLE_OPTIMIZE_ID = "OPT-K7MK9JL";
